import axiosInstance from "./axiosInstance.ts";
import type { InvestmentSummaryItem } from "./types.ts";

const getInvestmentSummary = async () => {
  const response = await axiosInstance.get(
    "/v3/biodiversity/units/sold/summary",
  );
  const payload = response?.data;

  if (Array.isArray(payload)) {
    return payload as InvestmentSummaryItem[];
  }

  if (Array.isArray(payload?.data)) {
    return payload.data as InvestmentSummaryItem[];
  }

  return [];
};

export default getInvestmentSummary;
